<template>
    <form ref='form' class='form' :class='formClasses'>
        <transition name='vue-form'>
            <div class='form__slot' v-if='!isSuccess'>
                <slot></slot>

                <vue-recaptcha
                    ref='recaptcha'
                    sitekey='6Lfw6EYoAAAAALOFNDytnBUucQVYaudIFD9DLM0T'
                    @verify='onVerify'
                    @expired='onExpired'
                    size='invisible'
                    badge='bottomleft'
                />
            </div>

            <div class='form__success' v-else>
                <div class='form__success__text'>
                    Thanks! Your inquiry was submitted successfully.
                </div>
            </div>
        </transition>

        <transition name='vue-form'>
            <div class='form__spinner' v-if='isPending'>
                <svg class='form__spinner__svg' xmlns='http://www.w3.org/2000/svg' height='64' width='64' viewBox='0 0 64 64'>
                    <defs>
                        <filter :id='`form-spinner-filter-${uid}`'>
                            <feGaussianBlur in='SourceGraphic' result='blur' stdDeviation='3'></feGaussianBlur>
                            <feColorMatrix in='blur' mode='matrix' result='goo' values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 19 -9'></feColorMatrix>
                            <feComposite in='SourceGraphic' in2='goo' operator='atop'></feComposite>
                        </filter>
                    </defs>
                    <g class='form__spinner__circles' :filter='`url(#form-spinner-filter-${uid})`'>
                        <circle cx='10' cy='32' r='7'></circle>
                        <circle cx='10' cy='32' r='7'></circle>
                        <circle cx='32' cy='32' r='7'></circle>
                        <circle cx='54' cy='32' r='7'></circle>
                    </g>
                </svg>
            </div>
        </transition>
    </form>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';

export default {
    name: 'AjaxForm',
    data() {
        return {
            isSuccess: false,
            isPending: false,
            isError: false
        }
    },
    computed: {
        uid () {
            return this.$.uid;
        },
        formClasses () {
            return {
                'state-pending': this.isPending,
                'state-error': this.isError
            }
        }
    },
    mounted () {
        this.$form = this.$el.querySelector('form');
        this.$formError = this.$refs.form.querySelector('form__error');
        this.$form.addEventListener('submit', this.onSubmit);
    },
    beforeUnmount () {
        if (this.$form) this.$form.removeEventListener('submit', this.onSubmit);
    },
    methods: {
        onSubmit (e) {
            e.preventDefault();

            if(this.$form.checkValidity()) {
                this.$refs.recaptcha.execute();
            }
        },
        onVerify (response) {
            // console.log('Verify: ' + response);

            this.isPending = true;

            const $form = this.$form;
            const xhr = new XMLHttpRequest();
            const data = new FormData($form);

            xhr.addEventListener('load', () => {
                this.isSuccess = true;
                this.isPending = false;
            });

            xhr.addEventListener('error', () => {
                this.isError = true;
                this.isPending = false;
            });

            xhr.open('POST', $form.getAttribute('action'));

            xhr.send(data);
        },
        onExpired () {
            // console.log('Expired')
        }
    },
    components: {
        VueRecaptcha
    }
};
</script>